import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=5f72fcd4&scoped=true"
import script from "./categories.vue?vue&type=script&lang=js"
export * from "./categories.vue?vue&type=script&lang=js"
import style0 from "./categories.vue?vue&type=style&index=0&id=5f72fcd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f72fcd4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconCategory: require('/app/components/v2/icons/IconCategory.vue').default})
